exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-4c9e3370]{font-weight:600;margin-bottom:.25rem}.subtitle[data-v-4c9e3370]{font-size:14px;color:#979797}.Stitle[data-v-4c9e3370]{padding:0 10px}.link_all[data-v-4c9e3370]{float:right;color:#0a7f78;font-size:14px;font-weight:500}.cut[data-v-4c9e3370]{margin-bottom:40px}.drag[data-v-4c9e3370]{overflow-x:scroll;padding:5px 10px 10px}.wdrag_list[data-v-4c9e3370]{display:flex;min-width:1760px}.wdrag_el[data-v-4c9e3370]{width:240px;margin-right:1rem}.drag_imgbox[data-v-4c9e3370]{border-radius:12px;overflow:hidden;position:relative;margin-bottom:10px}.drag_imgbox img[data-v-4c9e3370]{width:100%;display:block}.Bigvedio[data-v-4c9e3370]{position:absolute;z-index:80;height:50px;margin-right:-25px;margin-bottom:-25px;bottom:50%;right:50%;border-radius:50%;background:rgba(0,0,0,.2)}.Bigvedio .iconfont[data-v-4c9e3370]{font-size:50px;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4c9e3370","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/tips.vue
// module id = 47
// module chunks = 0